var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayAdminInfos.length !== 0)?_c('AdminInformationDialog',{key:_vm.currentDisplayAdminInfo.id,attrs:{"info":_vm.currentDisplayAdminInfo},on:{"close":_vm.handleCloseAndOpenNextAdminInfo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }